import {
  Calendar,
  Filter,
  Image,
  MessageSquare,
  Settings,
  Tag,
  Type,
} from "react-feather";
import {
  FaBell,
  FaBullhorn,
  FaHeadphones,
  FaList,
  FaMicrophone,
  FaMicrophoneAlt,
  FaMusic,
  FaPaintBrush,
  FaPhotoVideo,
  FaRegNewspaper,
  FaTasks,
  FaWrench,
  FaLanguage,
} from "react-icons/fa";
import { CgPlayList } from "react-icons/cg";

export default [
  {
    header: "Radio Data",
  },
  {
    id: "planning",
    acl: "planning",
    title: "Planning",
    icon: <FaTasks size={20} />,
    children: [
      {
        id: "emissions",
        acl: "emissions",
        title: "Emissions",
        icon: <FaMicrophoneAlt size={20} />,
        children: [
          {
            id: "view-emissions",
            acl: "view-emissions",
            title: "List Emissions",
            icon: <FaMicrophoneAlt size={20} />,
            navLink: "/admin/planning/emissions",
          },
          {
            id: "view-emissions-comment",
            acl: "view-emissions-comment",
            title: "List Comment",
            icon: <FaMicrophoneAlt size={20} />,
            navLink: "/admin/planning/emission/comments",
          },
        ],
      },
      {
        id: "view-episodes",
        acl: "view-episodes",
        title: "Episodes",
        icon: <FaHeadphones size={12} />,
        navLink: "/admin/planning/episodes",
      },
      {
        id: "planning_setting",
        acl: "planning_setting",
        title: "Setting",
        icon: <FaMicrophoneAlt size={20} />,
        children: [
          {
            id: "view-planning-category",
            acl: "view-planning-category",
            title: "List Categories",
            icon: <Type size={20} />,
            navLink: "/admin/planning/category",
          },
          {
            id: "view-planning-classification",
            acl: "view-planning-classification",
            title: "List Classification",
            icon: <Filter size={20} />,
            navLink: "/admin/planning/classification",
          },
          {
            id: "view-planning-language",
            acl: "view-planning-language",
            title: "List Language",
            icon: <FaLanguage size={20} />,
            navLink: "/admin/planning/language",
          },
          {
            id: "view-planning-tag",
            acl: "view-planning-tag",
            title: "List Tag",
            icon: <Tag size={20} />,
            navLink: "/admin/planning/tag",
          },
          {
            id: "view-background-image",
            acl: "view-background-image",
            title: "Background Image",
            icon: <Image size={20} />,
            navLink: "/admin/background_image",
          },
        ],
      },
    ],
  },
  {
    id: "view-default-playlist",
    acl: "view-default-playlist",
    title: "Default Playlist",
    icon: <CgPlayList size={20} />,
    navLink: "/admin/default_playlist",
  },
  {
    id: "view-calendar",
    acl: "view-calendar",
    title: "Calendar",
    icon: <Calendar size={20} />,
    navLink: "/admin/calendar",
  },
  {
    id: "view-live-waiting-room",
    acl: "view-live-waiting-room",
    title: "Live Waiting Room",
    icon: <FaMicrophone size={20} />,
    navLink: "/admin/live/waiting_room",
  },
  {
    id: "podcasts",
    acl: "podcasts",
    title: "Podcasts",
    icon: <FaMicrophoneAlt size={20} />,
    children: [
      {
        id: "view-podcasts",
        acl: "view-podcasts",
        title: "Podcasts List",
        icon: <FaRegNewspaper size={20} />,
        navLink: "/admin/podcasts",
      },

      {
        id: "view-podcasts-comments",
        acl: "view-podcasts-comments",
        title: "List Comment",
        icon: <MessageSquare size={20} />,
        navLink: "/admin/podcast/comments",
      },
    ],
  },
  {
    id: "rush",
    acl: "rush",
    title: "Rush",
    icon: <FaMicrophone size={20} />,
    children: [
      {
        id: "view-rushs",
        acl: "view-rushs",
        title: "List Rush",
        icon: <FaList size={20} />,
        navLink: "/admin/rushs",
      },
      {
        id: "view-rush-waiting-room",
        acl: "view-rush-waiting-room",
        title: "Waiting Room Rush",
        icon: <FaMicrophone size={20} />,
        navLink: "/admin/rush/waiting_room",
      },
    ],
  },
  /******* Multimedia */
  {
    id: "multimedia",
    acl: "multimedia",
    title: "Multimedia",
    icon: <FaPhotoVideo size={20} />,
    children: [
      {
        id: "view-songs",
        acl: "view-songs",
        title: "Songs",
        icon: <FaMusic size={20} />,
        navLink: "/admin/multimedia/songs",
      },
      {
        id: "view-albums",
        acl: "view-albums",
        title: "Albums",
        icon: <FaPhotoVideo size={12} />,
        navLink: "/admin/multimedia/albums",
      },
      {
        id: "view-artistes",
        acl: "view-artistes",
        title: "Artists",
        icon: <FaPaintBrush size={20} />,
        navLink: "/admin/multimedia/artistes",
      },
      {
        id: "view-jingles",
        acl: "view-jingles",
        title: "Jingles",
        icon: <FaBell size={12} />,
        navLink: "/admin/multimedia/jingles",
      },

      {
        id: "view-credits",
        acl: "view-credits",
        title: "Generics",
        icon: <FaWrench size={12} />,
        navLink: "/admin/multimedia/generics",
      },
      {
        id: "view-ads",
        acl: "view-ads",
        title: "Publicities",
        icon: <FaBullhorn size={12} />,
        navLink: "/admin/multimedia/publicities",
      },
      {
        id: "playlists",
        acl: "playlists",
        title: "Playlists",
        icon: <FaMusic size={12} />,
        children: [
          {
            id: "view-playlists",
            acl: "view-playlists",
            title: "List Playlists",
            icon: <FaMusic size={20} />,
            navLink: "/admin/multimedia/playlists",
          },
          {
            id: "view-playlist-comments",
            acl: "view-playlist-comments",
            title: "List Comment",
            icon: <FaMusic size={20} />,
            navLink: "/admin/multimedia/playlist/comments",
          },
        ],
      },
      {
        id: "view-categories-media",
        acl: "view-categories-media",
        title: "Categories",
        icon: <Settings size={12} />,
        navLink: "/admin/categories/media",
      },
      {
        id: "view-tags-media",
        acl: "view-tags-media",
        title: "Tags",
        icon: <Settings size={12} />,
        navLink: "/admin/tags/media",
      },
    ],
  },
];
